import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ProfileTestApi = createApi({
  reducerPath: "ProfileTestApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["PROFILETESTAPI"],
  endpoints: (build) => ({
    getProfileTest: build.query({
      query: ({
        page,
        search,
        limit,
        isAdminPanel,
        orgId,
        active,
        letter,
      }) => ({
        url: `/profiles?page=${page ?? ""}&search=${search ?? ""}&limit=${
          limit ?? ""
        }&isAdminPanel=${isAdminPanel}&orgId=${orgId ?? ""}&active=${
          active ?? ""
        }&letter=${letter ?? ""}`,
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
      providesTags: ["PROFILETESTAPI"],
    }),

    getProfileTestById: build.query({
      query: ({ id }) => ({
        url: `/profiles/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PROFILETESTAPI"],
    }),

    editProfileTest: build.mutation({
      query: ({ id, data }) => ({
        url: `/profiles/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PROFILETESTAPI"],
    }),

    addProfileTest: build.mutation({
      query: ({ data }) => ({
        url: `/profiles`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["PROFILETESTAPI"],
    }),
    bulkEditProfileOfferPrice: build.mutation({
      query: ({ data }) => ({
        url: `/profiles/bulk-offer-update`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TESTAPI"],
    }),
    deleteProfileTest: build.mutation({
      query: ({ id }) => ({
        url: `/profiles/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PROFILETESTAPI"],
    }),
  }),
});

export const {
  useGetProfileTestQuery,
  useGetProfileTestByIdQuery,
  useEditProfileTestMutation,
  useAddProfileTestMutation,
  useDeleteProfileTestMutation,
  useBulkEditProfileOfferPriceMutation,
} = ProfileTestApi;
